<div class="case-info-page">
  <div class="container-fluid">
    <div class="case-info-card">

      <a href="javascript:void(0)" class="back-link" (click)="backToRelationships()" (keyup.enter)="backToRelationships()">
        <i class="fa fa-chevron-left" aria-hidden="true"></i> Back to Relationships
      </a>

      <div class="case-info-header">
        <div class="header-title-row">
          <h2 class="client-name">
            <span class="client-name-label">List of Cases Shared by -</span>
            <span class="client-avatar">
              <img *ngIf="clientAvatarUrl" [src]="clientAvatarUrl" [alt]="clientName + ' avatar'" class="client-avatar-img">
              <span *ngIf="!clientAvatarUrl" class="client-avatar-initials" aria-hidden="true">{{ clientInitials }}</span>
            </span>
            <span class="client-name-highlight">{{ clientName }}</span>
          </h2>
        </div>
        <div class="cases-count-chip" *ngIf="!loading">{{ casesCountLabel }}</div>
      </div>

      <!-- Search + sort -->
      <div class="controls-row" *ngIf="!loading && casesShared.length > 0">
        <div class="search-field">
          <i class="fa fa-search search-icon" aria-hidden="true"></i>
          <input
            type="text"
            class="search-input"
            placeholder="Search cases by title or issue type..."
            aria-label="Search cases by title or issue type"
            [value]="searchTerm"
            (input)="onSearchChange($any($event.target).value)">
        </div>

        <div class="sort-field" #sortFieldRef>
          <span id="caseSortLabel" class="sort-label">Sort cases</span>
          <button
            type="button"
            class="sort-trigger"
            aria-haspopup="listbox"
            [attr.aria-expanded]="isSortMenuOpen"
            aria-labelledby="caseSortLabel sortTriggerText"
            (click)="toggleSortMenu()"
            (keydown.escape)="closeSortMenu()">
            <span id="sortTriggerText" class="sort-trigger-text">{{ sortLabel }}</span>
            <i class="fa fa-chevron-down sort-trigger-icon" [class.is-open]="isSortMenuOpen" aria-hidden="true"></i>
          </button>

          <ul class="sort-menu" role="listbox" *ngIf="isSortMenuOpen" aria-label="Sort cases">
            <li
              *ngFor="let option of sortOptions"
              role="option"
              tabindex="0"
              [attr.aria-selected]="option.value === sortOrder"
              class="sort-option"
              [class.is-selected]="option.value === sortOrder"
              (click)="selectSort(option.value)"
              (keydown.enter)="selectSort(option.value)"
              (keydown.escape)="closeSortMenu()">
              <span>{{ option.label }}</span>
              <i class="fa fa-check sort-option-check" *ngIf="option.value === sortOrder" aria-hidden="true"></i>
            </li>
          </ul>
        </div>
      </div>

      <!-- Loading -->
      <div class="loading-state" *ngIf="loading">
        <p class="loading-text">Loading cases…</p>
      </div>

      <!-- Zero cases -->
      <div class="empty-state-container" *ngIf="!loading && casesShared.length === 0">
        <img src="assets/img/e-relationship.png" class="empty-state-icon" alt="No cases">
        <p class="empty-state-title">No cases have been shared by this client.</p>
      </div>

      <!-- Search produced no matches -->
      <div class="empty-state-container" *ngIf="!loading && casesShared.length > 0 && filteredCases.length === 0">
        <p class="empty-state-title">No cases match your search.</p>
      </div>

      <!-- Case cards -->
      <div class="case-card-list" *ngIf="!loading && filteredCases.length > 0">
        <div class="case-card" *ngFor="let c of filteredCases" (click)="viewCase(c)" tabindex="0"
             role="button" [attr.aria-label]="'View ' + c.issueTitle"
             (keyup.enter)="viewCase(c)">
          <div class="case-card-icon" aria-hidden="true">
            <i class="fa fa-briefcase"></i>
          </div>

          <div class="case-card-content">
            <h3 class="case-title" [attr.title]="c.issueTitle">{{ c.issueTitle }}</h3>

            <p class="case-meta case-meta--issue" *ngIf="c.issueType?.length" [attr.title]="c.issueType.join(', ')">
              <span class="meta-label">Issue Type:</span> {{ c.issueType.join(', ') }}
            </p>
            <p class="case-meta"><span class="meta-label">Shared On:</span> 
              {{ c.sharedOn + 'Z' | date:'MMM d, yyyy, h:mm a':'Asia/Kolkata' }}
          </p>

            <div class="case-card-bottom">
              <p class="case-meta case-meta--docs" [attr.title]="'Documents Shared: ' + documentCount(c)"><span class="meta-label">Documents Shared:</span> {{ documentCount(c) }}</p>
              <button type="button" class="view-link" (click)="$event.stopPropagation(); viewCase(c)">View <i class="fa fa-chevron-right"></i></button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>